import { useLoaderData, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ASSET_ROUTE_URL } from '../../../constants/routes';
import { toUpperCase } from '../../../lib/stringHelpers';
import { useTradeFormStore } from '../TradeForm/TradeFormState';

export const useSyncUrlToTradeFormState = () => {
  const {
    product: { lotSize, tickSize },
  } = useLoaderData({ from: ASSET_ROUTE_URL });
  const { side, orderType } = useSearch({ from: ASSET_ROUTE_URL });

  useEffect(() => {
    const currentState = useTradeFormStore.getState();
    if (currentState.lotSize !== lotSize || currentState.tickSize !== tickSize) {
      useTradeFormStore.setState({ lotSize, tickSize });
    }
  }, [lotSize, tickSize]);

  useEffect(() => {
    const currentState = useTradeFormStore.getState();
    if (currentState.side !== side) {
      useTradeFormStore.setState({ side });
    }
  }, [side]);

  useEffect(() => {
    const currentState = useTradeFormStore.getState();
    const orderTypeUpper = toUpperCase(orderType);
    if (currentState.orderType !== orderTypeUpper) {
      useTradeFormStore.setState({ orderType: orderTypeUpper });
    }
  }, [orderType]);
};
